
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import type { CourseCardUIType } from '@xt/client/entities/my-v2/types'

@Component({
  components: {
    LazyImg
  }
})
export default class CourseCard extends Vue {
  @Prop({ required: true }) dataSource: CourseCardUIType

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
